export default __webpack_public_path__ + "static/media/cert.d58ee7f6.png";